import { VueModule } from '@Foundation/utilities';
import LoadMore from './code/Scripts/components/load-more';

export default VueModule({
  components: {
    LoadMore
  }
});
